export const emailValidator = (email: string): boolean => {
    const EMAIL_REGEX =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return EMAIL_REGEX.test(email.trim());
};

export const ssnValidator = (ssn: string): boolean => {
    const ssnRegex = /^(?!219099999|078051120)(?!666|000|9\d{2})\d{3}(?!00)\d{2}(?!0{4})\d{4}$/;
    if (typeof ssn == 'object' || typeof ssn == 'undefined') {
        return false;
    }
    return ssnRegex.test(typeof ssn === 'number' ? ssn : ssn.trim());
};

export const phoneValidator = (phone: string): boolean => {
    const PHONE_REGEX = /^\d{10}$/;

    return PHONE_REGEX.test(phone.trim());
};
